import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import '../styles/BookServicePage.css';

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const BookServicePage = () => {
  const query = useQuery();
  const serviceName = query.get("name") || "";
  const serviceDuration = query.get("duration") || "";
  const servicePrice = query.get("price") || "";

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [preferredDate, setPreferredDate] = useState('');
  const [preferredTime, setPreferredTime] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(`Booking Request Sent!\nService: ${serviceName}\nName: ${name}\nDate: ${preferredDate}\nTime: ${preferredTime}`);
  };

  return (
    <div className="book-service-container">
      <h1>Book {serviceName}</h1>
      <p>Complete the form below to finalize your booking request.</p>

      <div className="booking-wrapper">
        {/* Left Column: Pre-filled Service Details */}
        <div className="service-details">
          <h2>Service Details</h2>
          <p><strong>Service:</strong> {serviceName}</p>
          <p><strong>Duration:</strong> {serviceDuration}</p>
          <p><strong>Price:</strong> {servicePrice}</p>
        </div>

        {/* Right Column: Booking Form */}
        <div className="booking-form">
          <h2>Schedule Your Session</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <input type="text" placeholder="Your Name" value={name} onChange={(e) => setName(e.target.value)} required />
              <input type="email" placeholder="Your Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
            </div>
            <div className="form-group">
              <input type="tel" placeholder="Phone Number" value={phone} onChange={(e) => setPhone(e.target.value)} required />
              <input type="date" value={preferredDate} onChange={(e) => setPreferredDate(e.target.value)} required />
            </div>
            <div className="form-group">
              <input type="time" value={preferredTime} onChange={(e) => setPreferredTime(e.target.value)} required />
            </div>
            <textarea placeholder="Additional Requests (Optional)" value={message} onChange={(e) => setMessage(e.target.value)} rows="4"></textarea>
            <button type="submit">Submit Booking Request</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default BookServicePage;
